import React from "react";
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import product1 from "../asset/product1.jpg";
import product2 from "../asset/product2.jpg";
import product3 from "../asset/product3.jpg";
import product4 from "../asset/product4.jpg";

const Product = () => {
  return (
    <div id="Product" className="  justify-center items-center  ">
      <h2 className="text-center mt-3 font-extrabold text-4xl max-md:text-2xl font-EBGaramond ">
        {" "}
        Our Product
      </h2>
      <span className=" inline-flex justify-center items-center  w-[14%] ml-[43%] h-2"></span>
      <br />

      <Swiper
        // install Swiper modules
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
        className=" justify-center flex w-[100%]"
      >
        <SwiperSlide>
          <div className=" ">
            <div className="w-[80%] m-auto py-5 px-4 grid lg:grid-cols-2 gap-4  ">
              {/* left Side */}
              <div
                className="flex flex-col h-full justify-center"
                data-aos=""
                data-aos-duration="1000"
              >
                <div className="text-left max-md:text-sm">
                  <h2 className=" font-bold text-dark text-3xl max-md:text-3xl font-EBGaramond  ">
                    1. Vanilla Planifolia
                    <br />
                  </h2>
                </div>

                <p className="text-dark mb-4 text-2xl md:text-lg max-md:text-sm mt-4 font-Montserrat ">
                  These vanilla beans come from the fruit of an orchid variety
                  called Vanilla Planifolia. Typically the pods are longer, have
                  a strong sweet aroma, the pods are rounded, and they can range
                  in length from 10 to 21 cm, average Planifolia pods are around
                  15-21 cm.{" "}
                  {/* <span className="text-yellow-500">
                    so that we can become the first choice as a supplier of
                    seafood from Indonesia.
                  </span> */}
                  <br />
                  <span className="bg-primer inline-block w-[300px] h-1"></span>
                </p>
                <div className="bg-center max-sm:pt-2 max-sm:mb-2">
                  {/* <a
                    href="https://www.contoh.com"
                    class="bg-blue-500 hover:bg-blue-700  text-2xl text-white  font-bold py-2 px-4 mt-8 rounded max-sm:text-sm"
                  >
                    Download Catalog
                  </a> */}{" "}
                </div>
              </div>

              {/* right Side */}
              <div
                className="grid   w-[full]"
                data-aos=""
                data-aos-duration="2000"
              >
                <img src={product1} alt="Export Import Activity" />
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" ">
            <div className="w-[80%] m-auto py-5 px-4 grid lg:grid-cols-2 gap-4  ">
              {/* left Side */}
              <div
                className="flex flex-col h-full justify-center"
                data-aos=""
                data-aos-duration="1000"
              >
                <div className="text-left max-md:text-sm">
                  <h2 className=" font-bold text-dark text-3xl max-md:text-3xl font-EBGaramond  ">
                    2. Vanilla Tahitian (Tahitensis)
                    <br />
                  </h2>
                </div>

                <p className="text-dark mb-4  text-2xl md:text-lg max-md:text-sm mt-4 font-Montserrat ">
                  It has typically fatter and flatter pods, and have warm and
                  sweet with a smooth aroma. Their maximum length can't be
                  longer than planifolia, it’s maximum can be 21 cm, but the
                  average size of Tahiti pods is around 13-17 cm.{" "}
                  {/* <span className="text-yellow-500">
                    so that we can become the first choice as a supplier of
                    seafood from Indonesia.
                  </span> */}
                  <br />
                  <span className="bg-primer inline-block w-[300px] h-1"></span>
                </p>
                <div className="bg-center max-sm:pt-2 max-sm:mb-2">
                  {/* <a
                    href="https://www.contoh.com"
                    class="bg-blue-500 hover:bg-blue-700  text-2xl text-white  font-bold py-2 px-4 mt-8 rounded max-sm:text-sm"
                  >
                    Download Catalog
                  </a> */}{" "}
                </div>
              </div>

              {/* right Side */}
              <div
                className="grid   w-[full]"
                data-aos=""
                data-aos-duration="2000"
              >
                <img src={product2} alt="Export Import Activity" />
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" ">
            <div className="w-[80%] m-auto py-5 px-4 grid lg:grid-cols-2 gap-4  ">
              {/* left Side */}
              <div
                className="flex flex-col h-full justify-center"
                data-aos=""
                data-aos-duration="1000"
              >
                <div className="text-left max-md:text-sm">
                  <h2 className=" font-bold text-dark text-3xl max-md:text-3xl font-EBGaramond  ">
                    3. Dry Vanilla (Ekstrak)
                    <br />
                  </h2>
                </div>

                <p className="text-dark mb-4  text-xl md:text-lg max-md:text-sm mt-4 font-Montserrat">
                  Our meticulously sourced and carefully processed vanilla beans
                  offer a rich, aromatic experience that elevates your culinary
                  creations. With our extensive inventory, competitive prices,
                  and reliable supply chain, we are your trusted partner in
                  delivering unparalleled quality to satisfy the discerning
                  taste buds of customers worldwide. Enhance your products and
                  captivate customers with the unmatched essence of our
                  exquisite dry vanilla.
                  {/* <span className="text-yellow-500">
                    so that we can become the first choice as a supplier of
                    seafood from Indonesia.
                  </span> */}
                  <br />
                  <span className="bg-primer inline-block w-[300px] h-1"></span>
                </p>
                <div className="bg-center max-sm:pt-2 max-sm:mb-2">
                  {/* <a
                    href="https://www.contoh.com"
                    class="bg-blue-500 hover:bg-blue-700  text-2xl text-white  font-bold py-2 px-4 mt-8 rounded max-sm:text-sm"
                  >
                    Download Catalog
                  </a> */}{" "}
                </div>
              </div>

              {/* right Side */}
              <div
                className="grid   w-[full]"
                data-aos=""
                data-aos-duration="2000"
              >
                <img src={product3} alt="Export Import Activity" />
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" ">
            <div className="w-[80%] m-auto py-5 px-4 grid lg:grid-cols-2 gap-4  ">
              {/* left Side */}
              <div
                className="flex flex-col h-full justify-center"
                data-aos=""
                data-aos-duration="1000"
              >
                <div className="text-left max-md:text-sm">
                  <h2 className=" font-bold text-dark text-xl max-md:text-3xl font-EBGaramond  ">
                    4. Vanilla Powder
                    <br />
                  </h2>
                </div>

                <p className="text-dark mb-4  text-xl md:text-lg max-md:text-sm mt-4 font-Montserrat ">
                  Our Vanilla Powder is a high-quality, pure vanilla extract in
                  a convenient, easy-to-use powder form. It is made from
                  premium-grade vanilla beans, giving it a rich and creamy
                  flavor that elevates any dish. Use it in baking, cooking, and
                  other culinary applications to enhance the taste and aroma of
                  your creations. Ideal for those who desire the classic flavor
                  of vanilla without the hassle of measuring liquid extract.
                  {/* <span className="text-yellow-500">
                    so that we can become the first choice as a supplier of
                    seafood from Indonesia.
                  </span> */}
                  <br />
                  <span className="bg-primer inline-block w-[300px] h-1"></span>
                </p>
                <div className="bg-center max-sm:pt-2 max-sm:mb-2">
                  {/* <a
                    href="https://www.contoh.com"
                    class="bg-blue-500 hover:bg-blue-700  text-2xl text-white  font-bold py-2 px-4 mt-8 rounded max-sm:text-sm"
                  >
                    Download Catalog
                  </a> */}{" "}
                </div>
              </div>

              {/* right Side */}
              <div
                className="grid   w-[full]"
                data-aos=""
                data-aos-duration="2000"
              >
                <img src={product4} alt="Export Import Activity" />
              </div>
            </div>
          </div>
        </SwiperSlide>
        ...
      </Swiper>
    </div>
  );
};

export default Product;
